<template>
  <div>
  </div>
</template>

<script>
import storeFunctions from "@/data/functions/mixins/storeFunctions.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import announcements from "@/frame/messages/mixins/announcements.js";
export default {
  data() {
    return {
      timeDuration: 1000,
      checkCounter: 0,
      clickCounter: 0
    };
  },
  mixins: [announcements, apptheme, storeFunctions],
  beforeMount() {
    this.startTimeBlockTimer();
  },
  computed: {
    timeWarning() {
      // n x 1 sec is actual time
      let m = 60; // number of secocnd in 1 min
      let n = 10 * m; // number of minutes
      return n;
    },
    timeSignOut() {
      // n x 1 sec is actual time
      let m = 60; // number of secocnd in 1 min
      let n = 12 * m; // number of minutes
      return n;
    }
  },
  methods: {
    activityCounter() {
      this.clickCounter = this.clickCounter + 1;
    },
    startTimeBlockTimer() {
      // console.log("");
      // console.log("START TIMER");
      setTimeout(this.checkTimerCondition(), this.timeDuration);
    },
    checkTimerCondition() {
      // CHECK FOR CONDITIONS
      window.addEventListener("scroll", this.activityCounter, true);
      window.addEventListener("click", this.activityCounter, true);
      window.addEventListener("keydown", this.activityCounter, true);
      window.addEventListener("touchstart", this.activityCounter, true);
      window.addEventListener("touchend", this.activityCounter, true);
      window.addEventListener("touchcancel", this.activityCounter, true);
      window.addEventListener("touchmove", this.activityCounter, true);
      // CHECK EVERY 10 SECOND
      setTimeout(checkTimes, this.timeDuration);

      // START TIMER AGAIN
      let t = this;
      let counter = 1;
      function checkTimes() {
        counter = counter + 1;
        t.startTimeBlockTimer();
      }

      // CHECK CLICKS / TIMER CHECK
      if (this.clickCounter > 0 && this.checkCounter > 5) {
        this.checkCounter = 0;
        this.clickCounter = 0; // reset
      } else {
        // Increase Timer
        this.checkCounter = this.checkCounter + counter;
      }
      // WARN. MESSAGE
      if (this.checkCounter === this.timeWarning) {
        // eslint-disable-next-line
        let msg = "Idle timer was started, the application will automatically log off in few minutes.";
        this.generateIdleTimer(this.ui.colorBlue1, msg);
      }

      if (this.checkCounter === this.timeSignOut) {
        this.signOutIdleUser();
      }
    },
    signOutIdleUser() {
      this.$router.push("/autologoff");
      this.logoutStore();
    }
  }
};
</script>
